module.exports = __webpack_public_path__ + "img/product-discount-one.ee82263.png";